module.exports = __webpack_public_path__ + "static/media/Owner.a69fb489.jpg";